import { selectHelper } from '../../common/helpers'
import { messages } from '../../common/constants'


export const selectCategoriesForSelect = (state) => {
    const { categories } = state.category.categoryList
    var categoryValues = []

    if (!categories || categories.length == 0) return categoryValues
    categoryValues = selectHelper.getValuesForSelect(categories, 'id', 'name', messages.SELECT_ALL_VALUES)
    return categoryValues
}


// WEBPACK FOOTER //
// ./src/store/category/selector.js